<template>
  <div id="app">
    <router-view @resetPass="resetPass" />
    <el-dialog
      :visible="dialogVisible"
      width="100%"
      :fullscreen="true"
      center
      :show-close="dialogState == 3"
      :before-close="handleClose"
    >
      <div class="register dcontent" v-if="dialogState === 1">
        <div class="loginiv"></div>
        <div class="edit">
          <img
            src="/static/images/register_phone.png"
            alt=""
            style="width: 0.0833rem; height: 0.0833rem;"
          />
          <input
            type="text"
            placeholder="请输入手机号"
            v-model="register.phone"
          />
        </div>
        <div class="edit">
          <img
            src="/static/images/register_pass.png"
            alt=""
            style="width: 0.0833rem; height: 0.0833rem;"
          />
          <input
            type="password"
            placeholder="请输入密码"
            v-model="register.password"
          />
        </div>
        <div class="edit">
          <img
            src="/static/images/register_code.png"
            alt=""
            style="width: 0.0833rem; height: 0.0833rem;"
          />
          <input
            type="text"
            placeholder="请输入图形验证码"
            v-model="register.validCode"
          />
          <img :src="authCode" @click="v++" style="width: 0.4167rem;" />
        </div>
        <div class="edit">
          <img
            src="/static/images/register_code.png"
            alt=""
            style="width: 0.0833rem; height: 0.0833rem;"
          />
          <input
            type="text"
            placeholder="请输入验证码"
            v-model="register.code"
          />
          <div @click="sendRegisterSms()" class="getCode row">
            <!-- <ZSendSms style="width:5.4rem;"></ZSendSms> -->
          </div>
        </div>
        <!-- <div class="edit">
          <img src="/static/images/app_icon.png" alt="" style="width: 30px; height: 30px;">
          <input type="text" placeholder="请输入手机号">
        </div> -->
        <div class="registerbtn" @click="doregister()">
          注册
        </div>
        <div class="botbtns">
          <div class="gologin" @click="goLogin()">前去登录</div>
          <div class="wangjimima" @click="goRestPass()">忘记密码</div>
        </div>
      </div>
      <div class="login loginipt" v-if="dialogState === 2">
        <el-carousel
          :height="screenheight"
          style="width: 100%;"
          :autoplay="true"
          arrow="never"
          indicator-position="none"
        >
          <el-carousel-item v-for="item in bgiImg" :key="item">
            <img :src="item" alt="" class="loginimg" />
          </el-carousel-item>
        </el-carousel>
        <div class="opacity"></div>
        <div class="left">
          <div class="img">
            <img
              src="/static/images/login-text1.png"
              alt=""
              style="width:100%; height:100%"
            />
          </div>
          <p>The future has arrived</p>
          <div class="line"></div>
        </div>
        <div class="right">
          <div class="logintext">欢迎登录</div>
          <div class="edit2">
            <img
              src="/static/images/register_phone.png"
              alt=""
              style="width: 0.0833rem; height: 0.0833rem;"
            />
            <input
              type="text"
              placeholder="请输入手机号"
              v-model="login.phone"
              autocomplete="off"
            />
          </div>
          <div class="edit2">
            <img
              src="/static/images/register_pass.png"
              alt=""
              style="width: 0.0833rem; height: 0.0833rem;"
            />
            <input
              type="password"
              placeholder="请输入密码"
              v-model="login.password"
              autocomplete="off"
            />
          </div>

          <div
            :class="[this.changeColor ? 'gisterbtn' : 'registerbtn2']"
            @click="loginAPP()"
          >
            登录
          </div>
          <!-- <div class="botbtns">
            <div class="gologin2" @click="goRegister">前往注册</div>
            <div class="wangjimima2" @click="goRestPass">忘记密码</div>
          </div> -->
        </div>
        <div class="botText">
          <span style="margin-right: 32px;color: #666;">
            <a href="http://beian.miit.gov.cn/" target="_blank"
              >备案: 浙ICP备18030856号</a
            >
          </span>
          Copyright @ 2023. All rights reserved.泽玺科技 版权所有.
        </div>
      </div>
      <div class="resetpass dcontent" v-if="dialogState === 3">
        <img
          src="/static/images/close.png"
          class="popClose"
          @click="hideRestPass"
        />
        <div class="loginiv"></div>
        <!-- <div class="edit">
          <img src="/static/images/register_phone.png" alt="" style="width: 0.0833rem; height: 0.0833rem;">
          <input type="text" placeholder="请输入手机号" v-model="resetpass.phone">
        </div> -->
        <div class="edit">
          <img
            src="/static/images/register_pass.png"
            alt=""
            style="width: 0.0833rem; height: 0.0833rem;"
          />
          <input
            type="password"
            placeholder="请输入旧密码"
            v-model="resetpass.password"
          />
        </div>
        <div class="edit">
          <img
            src="/static/images/register_pass.png"
            alt=""
            style="width: 0.0833rem; height: 0.0833rem;"
          />
          <input
            type="password"
            placeholder="请输入新密码"
            v-model="resetpass.newPassword"
          />
        </div>
        <!-- <div class="edit">
          <img src="/static/images/register_code.png" alt="" style="width: 0.0833rem; height: 0.0833rem;">
          <input type="text" placeholder="请输入图形验证码" v-model="resetpass.validCode">
          <img :src="authCode" @click="v++" style="width: 0.4167rem;" />
        </div>
        <div class="edit">
          <img src="/static/images/register_code.png" alt="" style="width: 0.0833rem; height: 0.0833rem;">
          <input type="text" placeholder="请输入验证码" v-model="resetpass.code">
          <div @click="sendRestPassSms" class="getCode row">
            <ZSendSms style="width:0.4167rem;"></ZSendSms>
          </div>
        </div> -->
        <div class="registerbtn" @click="doRestPassNew">
          重置密码
        </div>
        <div class="botbtns">
          <div class="gologin" v-show="false" @click="goLogin">前去登录</div>
          <div class="wangjimima"></div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="系统通知"
      :visible.sync="iniviteVisible"
      width="30%"
      :before-close="handleIniviteClose"
    >
      <span>是否加入{{ CompanyInfo.companyName }}该公司</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jionCompan(2)">拒绝</el-button>
        <el-button type="primary" @click="jionCompan(1)">加入</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="servicemaintainVisible"
      width="40%"
      :before-close="servicemaintainClose"
    >
      <div class="selectPop">
        <div class="popTitle">通知信息</div>
        <div class="popText">
          {{ popText }}
        </div>
        <button class="konwBtn" @click="hidePop">我知道了</button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="agreementVisible"
      width="40%"
      :before-close="hideAgreement"
    >
      <div class="selectPop">
        <div class="popTitle">{{ agreement.agreementName }}</div>
        <div class="popText">
          {{ agreement.agreementContent }}
        </div>
        <button class="konwBtn" @click="hideAgreement(false)">
          不同意
        </button>
        <button class="konwBtn" @click="hideAgreement(true)">同意</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ZSendSms from "@/components/ZSendSms";
import {
  getAuthCode,
  sendSms,
  register,
  resetPwd,
  changePwd,
  getVersion
} from "@/api/login";
import {
  getCompanyInvite,
  companyInviteReply,
  getVersionLogsList,
  checkVersionLogs,
  agreementKnow
} from "@/api/user/userChatContent";
import { getToken } from "@/utils/auth";
import bus from "@/utils/bus";
import { getRadomStr } from "@/utils/util";
import md5 from "js-md5";
import version from "@/version/v";
import { formatDate } from "@/utils/date";
import { ar } from "date-fns/locale";
export default {
  name: "App",
  data() {
    return {
      bgiImg: [
        "/static/images/login1.webp",
        "/static/images/login2.webp",
        "/static/images/login3.webp"
      ],
      changeColor: false,
      dialogVisible: false,
      iniviteVisible: false,
      servicemaintainVisible: false,
      agreementVisible: false,
      dialogState: 2,
      agreement: {},
      token: getRadomStr(),
      CompanyInfo: {},
      popText: null,
      register: {
        phone: null,
        password: null
      },
      resetpass: {
        phone: null,
        password: null
      },
      login: {
        phone: null,
        password: null
      },
      v: 0,
      screenheight: document.documentElement.clientHeight + "px"
    };
  },
  computed: {
    authCode() {
      return getAuthCode() + this.token + "?" + this.v;
    }
  },

  mounted() {
    if (!getToken()) {
      this.dialogVisible = true;
      this.dialogState = 2;
    }
    bus.$on("showLogin", call => {
      this.showLogin();
    });

    bus.$on("showServiceMaintain", str => {
      this.popText = str;
      this.servicemaintainVisible = true;
    });

    bus.$on("showAgreement", str => {
      this.agreement = JSON.parse(str);
      this.agreementVisible = true;
    });

    // 版本更新通知

    getVersionLogsList().then(res => {
      if (res.data.length > 0) {
        const index = 1;
        let str = "";
        for (const rd of res.data) {
          str = str + index + rd.remark;
        }
        bus.$emit("showServiceMaintain", str);
      }
    });

    // 获取版本消息通知
    // const versionNotice = localStorage.getItem('versionNotice1.01', false)
    // if (!versionNotice) {

    // }

    window.onresize = () => {
      return (() => {
        this.screenheight = String(document.body.clientHeight) + "px";
      })();
    };
  },
  watch: {
    $route(to, from) {
      this.__version();
    }
  },

  methods: {
    __version() {
      if (localStorage.getItem("VERSION_TIME")) {
        const today = localStorage.getItem("VERSION_TIME");
        if (
          new Date(formatDate(new Date(), "yyyy-MM-dd hh:mm")).getTime() -
            new Date(today).getTime() >
          0
        ) {
          localStorage.setItem(
            "VERSION_TIME",
            formatDate(new Date(), "yyyy-MM-dd hh:mm")
          );
          this.getVersion();
        }
      } else {
        localStorage.setItem(
          "VERSION_TIME",
          formatDate(new Date(), "yyyy-MM-dd hh:mm")
        );
        this.getVersion();
      }
    },
    hideAgreement(agree) {
      this.agreementVisible = false;
      if (agree) {
        agreementKnow({
          id: this.agreement.agreementId
        }).then(res => {
          console.log("done");
        });
      }
    },
    hideRestPass() {
      this.dialogVisible = false;
    },
    getVersion() {
      getVersion().then(res => {
        console.log("比对版本");
        if (res.data !== version.data) {
          console.log("刷新成功");
          location.reload(true);
        }
      });
    },
    hidePop() {
      checkVersionLogs().then(res => {
        this.servicemaintainVisible = false;
      });
    },
    jionCompan(option) {
      companyInviteReply({
        state: option,
        id: this.CompanyInfo.id
      }).then(res => {
        console.log(res);
        this.iniviteVisible = false;
        bus.$emit("loginSucess");
      });
    },
    handleClose(done) {
      done();
      this.dialogVisible = false;
    },
    handleIniviteClose(done) {
      done();
      this.iniviteVisible = false;
    },
    servicemaintainClose(done) {
      done();
      this.servicemaintainVisible = false;
    },
    goLogin() {
      this.dialogState = 2;
    },
    loadChatInfo() {
      // 加载热门问题
      // 如果已经登陆架加载对话列表
    },
    doRestPass() {
      if (!this.resetpass.phone || this.resetpass.phone.length < 11) {
        return this.$message("请输入正确的手机号码");
      }
      // if (!this.temp.username) {
      //   return this.$toast("请输入正确的账户");
      // }
      if (!this.resetpass.code || this.resetpass.code.length < 6) {
        return this.$message("请输入正确验证码");
      }
      if (!this.resetpass.password) {
        return this.$message("请输入密码");
      }
      // if (!this.temp.confirmPassword) {
      //   return this.$toast("请输入确认密码");
      // }
      // if (this.temp.password !== this.temp.confirmPassword) {
      //   return this.$toast("请确认两次输入的登录密码是否一致");
      // }

      resetPwd(this.resetpass).then(data => {
        this.$message("修改成功");
        this.dialogVisible = false;
      });
    },
    doRestPassNew() {
      // if (!this.temp.username) {
      //   return this.$toast("请输入正确的账户");
      // }

      if (!this.resetpass.password) {
        return this.$message("请输入旧密码");
      }
      if (!this.resetpass.newPassword) {
        return this.$message("请输入新密码");
      }
      // if (!this.temp.confirmPassword) {
      //   return this.$toast("请输入确认密码");
      // }
      // if (this.temp.password !== this.temp.confirmPassword) {
      //   return this.$toast("请确认两次输入的登录密码是否一致");
      // }
      this.resetpass.password = md5(this.resetpass.password + "shuaigege");
      changePwd(this.resetpass)
        .then(data => {
          this.$message("修改成功");
          this.dialogVisible = false;
        })
        .catch(e => {
          this.$message("修改失败");
        });
    },
    goRegister() {
      // this.dialogState = 1
    },
    goRestPass() {
      // this.dialogState = 3
    },
    showLogin() {
      this.dialogVisible = true;
      this.dialogState = 2;
    },
    resetPass() {
      this.dialogVisible = true;
      this.dialogState = 3;
    },
    async loginAPP() {
      this.changeColor = !this.changeColor;
      if (!this.login.phone) {
        return this.$message("请输入正确的账户");
      }
      if (!this.login.password || this.login.password.length < 1) {
        return this.$message("请输入正确的密码");
      }

      this.$store.dispatch("Login", this.login).then(res => {
        this.dialogVisible = false;
        this.$message({ message: "登录成功", type: "success" });
        // 在此处处理
        getCompanyInvite().then(res => {
          if (res.data.length > 0) {
            this.CompanyInfo = res.data[0];
            this.iniviteVisible = true;
            console.log(res);
          } else {
            bus.$emit("loginSucess");
            console.log("登录成功 app");
          }
        });
      });
    },
    registerUser() {},
    resetPassWord() {},
    // 重置密码发送验证码
    sendRestPassSms() {
      if (!this.resetpass.phone || this.resetpass.phone < 11) {
        return this.$message("请输入正确的手机号码");
      }
      if (!this.resetpass.validCode || this.resetpass.validCode.length !== 4) {
        return this.$message("请输入正确的图形验证码");
      }
      bus.$emit("sendSms", ok => {
        sendSms({
          phone: this.resetpass.phone,
          validCode: this.resetpass.validCode,
          type: 2,
          deviceId: this.token
        })
          .then(data => {
            ok();
            this.$message("验证码发送成功!");
            this.referCode();
          })
          .catch(res => {
            ok(res.resultMsg);
          });
      });
    },
    doRegister() {
      if (!this.register.username || this.temp.register.length < 6) {
        return this.$message("账户不能为空,并且必须大于6位");
      }
      if (!this.register.code || this.register.code.length !== 6) {
        return this.$message("请输入正确的短信验证码");
      }
      if (!this.register.password || this.register.password.length < 6) {
        return this.$message("请输入正确的登陆密码");
      }
      register({
        phone: this.register.username,
        code: this.register.code,
        password: this.register.password,
        inviteCode: "",
        username: this.register.username,
        channelCode: "",
        deviceId: "aaa"
      })
        .then(res => {
          this.$message("注册成功!");
          this.$store
            .dispatch("Login", {
              username: this.temp.username,
              password: this.temp.password,
              deviceId: "aaa"
            })
            .then(res => {
              //
              this.$message("登录成功");
            })
            .catch(res => {
              this.$router.replace("/chat");
            });
        })
        .catch(res => {
          this.referCode();
        });
    },
    // 注册发送验证码
    sendRegisterSms() {
      if (!this.register.phone || this.register.phone < 11) {
        return this.$message("请输入正确的手机号码");
      }
      if (!this.register.validCode || this.register.validCode.length !== 4) {
        return this.$message("请输入正确的图形验证码");
      }
      bus.$emit("sendSms", ok => {
        sendSms({
          phone: this.register.phone,
          validCode: this.register.validCode,
          type: 0,
          deviceId: this.token
        })
          .then(data => {
            ok();
            this.$message("验证码发送成功!");
            this.referCode();
          })
          .catch(res => {
            ok(res.resultMsg);
          });
      });
    },
    referCode() {
      this.v = this.v + 1;
    }
  },
  destroyed() {
    bus.$off("showLogin");
    bus.$off("showServiceMaintain");
    bus.$off("showAgreement");
  },
  components: {
    ZSendSms
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: 0;
}

.dcontent {
  border-radius: 24px;
  width: 400px;
  background: #fff;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  margin-top: 70px;
  box-shadow: 0px 14px 36px 0px rgba(27, 28, 30, 0.2);
  border-radius: 20px;
  padding: 40px;
}

.botText {
  position: absolute;
  font-size: 12px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
  z-index: 77;
}

.popText {
  width: 90%;
  height: 270px;
  padding: 20px;
  font-size: 18px;
  color: #edf8ff;
  background: #0a0e1a;
  border-radius: 10px;
}

a {
  outline: none;
  color: inherit;
  /* 继承父元素的文本颜色 */
  text-decoration: none;
  /* 去除下划线 */
}

.loginiv {
  width: 112px;
  margin-bottom: 62px;
  margin-top: 20px;
  height: 128px;
  background-image: url("/static/images/loginiv.png");
  background-size: 100% 100%;
}

.edit {
  display: flex;
  justify-content: center;
  padding-left: 20px;
  padding-right: 20px;
  align-items: center;
  height: 60px;
  font-size: 15px;
  margin-bottom: 16px;
  border-radius: 18px;
  border: 1px solid #d6d8dc;
  width: 330px;
}

.edit2 {
  display: flex;
  justify-content: center;
  padding-left: 55px;
  padding-right: 20px;
  align-items: center;
  height: 60px;
  font-size: 15px;
  margin-bottom: 30px;
  border-radius: 18px;
  border: 1px solid #00a2ff;
  width: 478px;
}

.popClose {
  position: absolute;
  right: 30px;
  top: 14px;
  width: 18px;
  height: 18px;
}

.resetpass {
  position: relative;
}

.bigFont {
  font-size: 15px;
}

::-webkit-scrollbar {
  display: none;
}

.edit input {
  flex-grow: 1;
  padding-left: 12px;
  height: 100%;
  font-size: 15px;
  background: none;
  border: none;
  outline: none;
}

.selectPop {
  background: #141825;
  border-radius: 13px;
  border: 1px solid;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 10%;
  width: 100%;
  padding-top: 14px;
  padding-bottom: 14px;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

>>> .el-dialog {
  background: transparent;
}

.edit2 input {
  flex-grow: 1;
  padding-left: 12px;
  height: 100%;
  font-size: 15px;
  background: none;
  border: none;
  outline: none;
  color: #fff;
}

.edit2 input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.registerbtn {
  width: 330px;
  height: 60px;
  background: #03aff4;
  box-shadow: 0px 4px 18px 0px rgba(90, 147, 221, 0.5);
  border-radius: 35px;
  font-size: 18px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 60px;
  margin-top: 24px;
}

.registerbtn2 {
  width: 478px;
  height: 60px;
  background: linear-gradient(270deg, #00f4fd 0%, #00a2ff 100%);
  box-shadow: 0px 4px 18px 0px rgba(90, 147, 221, 0.5);
  border-radius: 35px;
  font-size: 18px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 60px;
  margin-top: 46px;
}

.popTitle {
  font-size: 20px;
  margin-bottom: 0.125rem;
  text-align: center;
  width: 100%;
  color: #fff;
}

.konwBtn {
  width: 120px;
  height: 40px;
  outline: none;
  border: none;
  color: #fff;
  margin-top: 14px;
  font-size: 18px;
  margin-bottom: 14px;
  background: #03aff4;
  border-radius: 10px;
}

.gisterbtn {
  width: 478px;
  height: 60px;
  background: linear-gradient(90deg, #00f4fd 0%, #00a2ff 100%);
  box-shadow: 0px 4px 18px 0px rgba(90, 147, 221, 0.5);
  border-radius: 35px;
  font-size: 18px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 60px;
  margin-top: 46px;
}

.gologin {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
}

.gologin2 {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
}

.el-dialog {
  border-radius: 24px;
}

/* .el-carousel__arrow {
  position: relative;
} */
.botbtns {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 42px;
  height: 25px;
}

.wangjimima {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
}

.wangjimima2 {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
}

.loginipt {
  /* background-image: url("/static/images/login1.png"); */
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.loginimg {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  display: flex;
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
  position: relative;
  object-fit: cover;
}

.loginipt .left {
  position: absolute;
  top: 50%;
  /* margin-right: 387px; */
  left: 10%;
  transform: translate(0, -50%);
  z-index: 77;
}

.opacity {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
  z-index: 70;
}

.left .img {
  width: 318px;
  height: 59px;
}

.loginipt .left p {
  height: 49px;
  font-size: 44px;
  font-family: ArialMT;
  color: #ffffff;
  line-height: 50px;
  margin-top: 53px;
}

.loginipt .left .line {
  margin-top: 193px;
  width: 106px;
  height: 4px;
  background: #ffffff;
}

.loginipt .right {
  position: absolute;
  top: 50%;
  right: 10%;
  transform: translate(0, -50%);
  width: 668px;
  height: 538px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 36px;
  padding: 0 95px;
  z-index: 77;
}

.right .logintext {
  margin: 53px 179px 46px 179px;
  width: 120px;
  height: 42px;
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 42px;
}

.edit input {
  width: 141px;
}

>>> .thinkWarp {
  background: #03204e !important;
  color: #fff !important;
  border: 1px solid #0368f9 !important;
}

>>> .el-popover {
  background: #000022;
  border-color: #000022;
  border-radius: 10px;
  opacity: 0.92;
  color: #fff;
}

>>> .el-popper[x-placement^="top"] .popper__arrow::after {
  border-top-color: #000022;
}

>>> .el-popper[x-placement^="top"] .popper__arrow {
  border-top-color: #000022;
}

>>> .el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #000022;
}

>>> .el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #000022;
}

>>> .el-dialog__header {
  height: 0px;
  display: none;
}

>>> .el-dialog__body {
  padding: 0;
}

/* >>>input:-webkit-autofill,
>>>input:-webkit-autofill:hover,
>>>input:-webkit-autofill:focus {
  border: 1px solid rgba(255, 255, 255, 0.25);
  -webkit-text-fill-color: #000;
  -webkit-box-shadow: 0 0 0px 1000px rgb(232, 240, 254) inset;
  transition: background-color 5000s ease-in-out 0s;
} */

/* input:-internal-autofill-previewed,
input:-internal-autofill-selected {
  appearance: menulist-button;
  background-image: none !important;
  background-color: transparent !important;
  color: fieldtext !important;
  -webkit-text-fill-color: transparent !important;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue